<template>
    <div class="searchTop">
        <div class="container">
            <div class="inputBox py-3 d-flex align-items-center">
                <input
                    placeholder="Search..."
                    type="text"
                    class="flex-grow-1"
                    :value="searchValue"
                    @keyup="evt=>{ searchValue=evt.target.value; updateSearch()}"
                    @blur="saveSearch"
                    v-if="getLng() == 'en'"
                >
                <input
                    placeholder="Búsqueda..."
                    type="text"
                    class="flex-grow-1"
                    :value="searchValue"
                    @keyup="evt=>{ searchValue=evt.target.value; updateSearch()}"
                    @blur="saveSearch"
                    v-else
                >
                <div class="closeBox p-1 ml-2" @click="closeSearch">
                    <img :src="getStaticImage('icon-clear.png')">
                </div>
            </div>
            <transition name="fadeHeight">
                <div v-if="recentSearch.length" class="recentSearch">
                    <h4>{{ $t('search.Recent Searches') }}</h4>
                    <div class="d-flex justify-content-center align-items-center flex-wrap">
                        <div class="item" v-for="item in recentSearch" @click="updateSearch(item)" >{{item}}</div>
                    </div>
                </div>
            </transition>
            
        </div>
        
        
        
        <div class="listSearch">
            
            <transition
                v-bind:css="false"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-on:leave="leave"
            >
                 <div class="text-center" v-if="ajaxCall">
                     <Loader ></Loader>
                 </div>
                
            </transition>
            
            <transition-group
                name="staggered-fade"
                tag="ul"
                v-bind:css="false"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-on:leave="leave"
            >
                <li v-if="Object.keys(searchList.products).length && searchValue"
                    v-for="(item, index) in searchList.products"
                    :key="('product'+item.id)"
                    v-bind:data-index="index"
                >
                    <router-link class="container" :to="{name: 'products', query: { product : item.id, brand : ((item.brand == 'reál-cocktail-ingredients') ? 'real' : 'finest') }}">
                        <span class="name">{{item.title}}</span>
                        <span class="type">{{ $t('search.product') }}</span>
                    </router-link>
                    
                </li>
                <li
                    v-if="Object.keys(searchList.recipes).length && searchValue"
                    v-for="(item, index) in searchList.recipes"
                    :key="('recipes'+item.id)"
                    v-bind:data-index="(index + Object.keys(searchList.products).length)"
                >
                    <router-link class="container"  :to="{name: 'recipes', query: { recipe : item.id }}">
                        <span class="name">{{item.title}}</span>
                        <span class="type">{{ $t('search.recipe') }}</span>
                    </router-link>
                    
                </li>
                <li v-if="searchValue &&  searchList.nothing" :key="100"><h3 class="text-center container">{{ $t('search.Nothing Found') }}</h3></li>
            </transition-group>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Loader from "./Loader"
    import Velocity from 'velocity-animate'

    export default {
        name: "Search",
        components: {Loader},
        data() {
            return {
                timeOut: null,
                searched: false,
                searchValue: "",
                ajaxCall: false
            }
        },
        methods: {
            closeSearch() {
                this.settings.show_search = false
            },
            updateSearch(val) {
                
                if(val){
                    this.searchValue = val;
                }
                
                if (this.searchValue){
                    this.searched = true;
                    this.ajaxCall = true;
                }else{
                    this.searched = false;
                }
                
                clearTimeout(this.timeOut);
                this.timeOut = setTimeout(() => this.$store.dispatch("app_search/getSearch", this.searchValue), 500);
            },
            saveSearch() {
                const val = this.searchValue.trim();
                
                setTimeout(()=>{
                    if (this.recentSearch.indexOf( val ) === -1 && val ){
                        if (this.recentSearch.length >= 6) { //Remove first if more than
                            this.recentSearch.splice(0,1);
                        }
                        this.recentSearch.push( val );
                        window.localStorage.setItem("recentSearch", JSON.stringify(this.recentSearch) );
                    }
                }, 1000);
                
            },
            getLng() {
                return localStorage.getItem( 'lng' ) || 'en';
            },
            //#####################################
            //Animation

            beforeEnter: function (el) {
                el.style.opacity = 0;
                el.style.height = 0;
            },
            enter: function (el, done) {
                var delay = el.dataset.index * 150;
                setTimeout(function () {
                    Velocity(
                            el,
                            {opacity: 1, height: '60px'},
                            {complete: done}
                    )
                }, delay)
            },
            leave: function (el, done) {
                var delay = el.dataset.index * 150;
                setTimeout(function () {
                    Velocity(
                            el,
                            {opacity: 0, height: 0},
                            {complete: done}
                    )
                }, delay)
            }
            //#####################################
        },
        computed: {
            ...mapState("shared", ["settings"]),
            ...mapState("app_search", ["searchList","recentSearch"])
        },
        watch:{
            searchList(){
                this.ajaxCall = false;
            }
        }
    }
</script>
